module.exports = __webpack_public_path__ + "static/media/DunolaOladapo.238824f8.jpg";